export default __webpack_public_path__ + "static/media/quick-reply.766ffc95.svg";